<template>
  <v-row no-gutters>
    <v-col>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack"
        :color="snackColor"
        :timeout="snackTime"
        bottom
        right
      >
        {{ snackText }}
      </v-snackbar>

      <v-dialog v-model="dialogNew" max-width="700">
        <v-card>
          <v-card-title> Agregar Servicio de Conexión </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="model.numeroAsistencia"
                    label="Número de Asistencia"
                    :rules="[(v) => !!v || 'Campo requerido']"
                    outlined
                    dense
                  />
                </v-col>

                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="model.direccion"
                    label="Dirección"
                    outlined
                    dense
                  />
                </v-col>

                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    v-model="model.telefono"
                    label="Teléfono"
                    outlined
                    dense
                  />
                </v-col>

                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    v-model="model.correo"
                    label="Correo"
                    outlined
                    dense
                  />
                </v-col>

                <v-col cols="12" md="6" class="py-0">
                  <v-select
                    v-model="model.tipoServicioConexionId"
                    :items="tipoFacturas"
                    label="Tipo de Documento"
                    item-value="tipoServicioConexionId"
                    item-text="nombre"
                    :rules="[(v) => !!v || 'Campo requerido']"
                    dense
                    outlined
                  ></v-select>
                </v-col>

                <v-col cols="12" md="6" class="py-0">
                  <v-select
                    v-model="model.formaPago"
                    :items="formasPago"
                    label="Forma de Pago"
                    :rules="[(v) => !!v || 'Campo requerido']"
                    outlined
                    dense
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions class="pb-4 pt-0 px-6">
            <v-spacer />

            <v-btn text @click="cerrar"> Cancelar </v-btn>

            <v-btn color="primary" :loading="loading" @click="guardar">
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- CONFIRM DIALOG -->
      <v-dialog v-model="confirmDialog" persistent max-width="400">
        <v-card>
          <v-card-title class="headline sisa-text">
            {{ confirmTitle }}
          </v-card-title>
          <v-card-text class="subtitle-1"> {{ confirmText }} </v-card-text>
          <v-card-actions class="px-6 pb-4">
            <v-btn color="sisa" outlined @click="confirmDialog = false">
              Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="sisa" dark @click="habilitarEdicion"> Si </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :loading="loader"
        loading-text="Listando Datos..."
        class="elevation-1"
      >
        <template v-slot:top>
          <v-layout class="px-3">
            <h2 class="py-4">Listado de Servicios de Conexión</h2>
          </v-layout>

          <v-divider></v-divider>
          <v-layout row class="mt-6 mb-4 px-4">
            <v-flex xs12 sm12 md4 class="px-2">
              <v-text-field
                class="text-xs-center"
                v-model="search"
                append-icon="search"
                label="Búsqueda"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm12 md2 class="px-2">
              <v-text-field
                v-model="fechaInicio"
                type="date"
                hide-details
                label="Inicio"
                :max="new Date().toISOString().substr(0, 10)"
                clearable
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm12 md2 class="px-2">
              <v-text-field
                v-model="fechaFin"
                type="date"
                hide-details
                label="Fin"
                :max="new Date().toISOString().substr(0, 10)"
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md1 class="text-center pt-3" align-self-center>
              <v-btn
                color="green"
                :block="$vuetify.breakpoint.smAndDown"
                dark
                @click="downloadReporte"
              >
                <v-icon>fas fa-file-excel</v-icon>
              </v-btn>
            </v-flex>

            <v-flex xs12 sm12 md1 class="text-center pt-3" align-self-center>
              <v-btn color="blue" dark @click="listar" block> Listar </v-btn>
            </v-flex>
            <v-flex xs12 sm12 md1 class="text-center pt-3" align-self-center>
              <v-btn
                color="primary"
                :block="$vuetify.breakpoint.smAndDown"
                dark
                @click="dialogNew = true"
              >
                <v-icon>fas fa-plus</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <v-chip :color="getColorEstado(item.estado)" dark>
            {{ getEstadoName(item.estado) }}
          </v-chip>
        </template>

        <template v-slot:[`item.tipoServicioConexionId`]="{ item }">
          {{ getNombreTipo(item.tipoServicioConexionId) }}
        </template>

        <template v-slot:[`item.faltaComprobanteEfectivo`]="{ item }">
          <v-icon
            v-if="item.faltaComprobanteEfectivo != null"
            :color="item.faltaComprobanteEfectivo ? 'red' : 'green'"
          >
            {{
              item.faltaComprobanteEfectivo ? "fas fa-times" : "fas fa-check"
            }}
          </v-icon>
          <span v-else>N/A</span>
        </template>

        <template v-slot:[`item.opciones`]="{ item }">
          <v-tooltip left color="primary" v-if="item.estado != 5">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                text
                class="pa-0"
                @click="verArchivos(item.numeroAsistencia)"
              >
                <v-icon color="primary"> fas fa-cloud </v-icon>
              </v-btn>
            </template>
            <span>Ver Archivos</span>
          </v-tooltip>
          <v-tooltip left color="amber accent-4" v-if="puedeReiniciar">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                text
                class="pa-0"
                @click="mostrarConfirmacion(item.numeroAsistencia)"
              >
                <v-icon color="amber accent-4"> fas fa-undo-alt </v-icon>
              </v-btn>
            </template>
            <span>Habilitar edición</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>
  
  <script>
import axios from "axios";
import XLSX from "xlsx";
import moment from "moment";

export default {
  name: "HistorialServiciosConexion",
  data: () => ({
    valid: false,
    loading: false,
    formasPago: ["Transferencia", "Efectivo"],
    model: {
      numeroAsistencia: "",
      direccion: "",
      correo: "",
      telefono: "",
      tipoServicioConexionId: 1,
      formaPago: "Transferencia",
    },
    dialogNew: false,
    fechaInicio: new Date().toISOString().substr(0, 10),
    fechaFin: new Date().toISOString().substr(0, 10),
    loader: false,
    search: "",
    numeroAsistencia: null,
    tipoFacturas: [],
    confirmDialog: false,
    confirmTitle: "Confirmación",
    confirmText:
      "¿Está seguro que desea habilitar la edición de este servicio de conexión?",
    estadosServiciosConexion: [],
    snack: false,
    snackColor: "primary",
    snackText: "Test",
    snackTime: 4500,
    headers: [
      { text: "Número Asistencia", value: "numeroAsistencia" },
      {
        text: "Dirección",
        value: "direccion",
        align: "center",
      },
      { text: "Correo", value: "correo", align: "center" },
      { text: "Telefono", value: "telefono", align: "center" },
      {
        text: "Forma de Pago",
        value: "formaPago",
        align: "center",
      },
      {
        text: "Estado",
        value: "estado",
        align: "center",
      },
      {
        text: "Comp. Efectivo",
        value: "faltaComprobanteEfectivo",
        align: "center",
      },
      {
        text: "Tipo Servicio Conexion",
        value: "tipoServicioConexionId",
        align: "center",
      },
      { text: "Opciones", value: "opciones", align: "center" },
    ],
    items: [],
    dialog: false,
  }),
  created() {
    this.listar();
    this.listarCombobox();
  },
  computed: {
    puedeReiniciar() {
      /*
        1032: GLADYS ISABEL AVALOS
        1051: MILTON VLADIMIR MALDONADO
           1: ADMINISTRADOR 
      */

      return (
        this.$store.state.usuario.idUsuario == "1032" ||
        this.$store.state.usuario.idUsuario == "1051" ||
        this.$store.state.usuario.idUsuario == "1"
      );
    },
  },
  methods: {
    cerrar() {
      this.dialogNew = false;

      this.model = {
        numeroAsistencia: this.numeroAsistencia,
        direccion: "",
        correo: "",
        telefono: "",
        tipoServicioConexionId: 1,
        formaPago: "Transferencia",
      };

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async guardar() {
      if (!this.$refs.form.validate()) return;

      try {
        this.loading = true;

        await axios.post("/api/ServiciosConexion", {
          numeroAsistencia: this.model.numeroAsistencia,
          direccion: this.model.direccion,
          correo: this.model.correo,
          telefono: this.model.telefono,
          tipoServicioConexionId: this.model.tipoServicioConexionId,
          estado: 3,
          formaPago: this.model.formaPago,
        });

        this.snackColor = "primary";
        this.snackText = "Registro agregado!";
        this.snack = true;

        this.cerrar();
      } catch (error) {
        console.error(error.response?.data || "Error al crear el servicio");
        this.snackColor = "error";
        this.snackText = "Error al crear el servicio...";
        this.snack = true;
      } finally {
        this.loading = false;
      }
    },
    mostrarConfirmacion(numeroAsistencia) {
      this.confirmDialog = true;
      this.numeroAsistencia = numeroAsistencia;
    },
    getNombreTipo(item) {
      const tipo = this.tipoFacturas.filter((tf) => {
        return tf.tipoServicioConexionId == item;
      });

      if (tipo.length > 0) {
        return tipo[0].nombre;
      }

      return "N/A";
    },
    getEstadoName(item) {
      const estado = this.estadosServiciosConexion.filter(
        (e) => e.estadoId == item
      );
      if (estado.length > 0) {
        return estado[0].nombre;
      }
      return "";
    },
    getColorEstado(item) {
      switch (item) {
        case 1:
          return "red";
          break;
        case 2:
          return "red";
          break;
        case 3:
          return "amber";
          break;
        case 4:
          return "green";
          break;
        default:
          return "gray";
          break;
      }
    },
    listar() {
      this.loader = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `api/ServiciosConexion/Todos?inicio=${this.fechaInicio}&fin=${this.fechaFin}`,
          configuracion
        )
        .then((res) => (this.items = res.data))
        .catch((err) => console.error(err))
        .finally(() => (this.loader = false));
    },
    listarCombobox() {
      axios
        .get("api/TipoServicioConexion")
        .then((res) => {
          this.tipoFacturas = res.data;
        })
        .catch((err) => {
          console.error(err);
        });

      axios
        .get("api/EstadosServicioConexion")
        .then((res) => (this.estadosServiciosConexion = res.data))
        .catch((err) => console.log(err));
    },
    formatDateTime(fecha) {
      if (fecha == null) return "- - - -";
      if (!fecha || typeof fecha != "string") {
        throw new Error(
          "El parametro 'fecha' debe ser de tipo String y no puede estar vacio"
        );
      }

      const d = new Date(fecha);

      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      };

      const formattedDate = new Intl.DateTimeFormat("sv-ES", options).format(d);
      return formattedDate;
    },
    verArchivos(numeroAsistencia) {
      window.open(
        `${process.env.VUE_APP_AXIOS}/adminArchivosConexion/${numeroAsistencia}`,
        "_blank"
      );
    },
    habilitarEdicion() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .put(
          `api/ServiciosConexion/Reiniciar/${this.numeroAsistencia}`,
          null,
          configuracion
        )
        .then((res) => {
          this.listar();
          this.snackColor = "primary";
          this.snackText = "Se habilitó la modificación del servicio!";
          this.snack = true;
        })
        .catch((err) => {
          console.error(err);
          this.snackColor = "error";
          this.snackText = "No se pudo reiniciar el servicio...";
          this.snack = true;
        })
        .finally(() => {
          this.confirmDialog = false;
        });
    },
    downloadReporte() {
      const formatDate = (date) => {
        if (!date) return "";
        return moment(date).format("YYYY-MM-DD HH:mm:ss");
      };

      const listadoLogs = this.items.map((item) => {
        const log = {
          "Número Asistencia": item.numeroAsistencia,
          Dirección: item.direccion,
          Correo: item.correo,
          "Forma de Pago": item.formaPago,
          Tipo: this.getNombreTipo(item.tipoServicioConexionId),
          Fecha: item.fecha ? formatDate(item.fecha) : "",
          Estado: item.estado ? this.getEstadoName(item.estado) : "",
        };

        return log;
      });

      let data = XLSX.utils.json_to_sheet(listadoLogs);
      const workbook = XLSX.utils.book_new();
      const filename = `Servicios Conexión ${this.fechaInicio} a ${this.fechaFin}`;

      XLSX.utils.book_append_sheet(workbook, data, "Servicios");
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
  },
};
</script>